// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_21fc4de","container":"_872f35f","label":"_7f9d15c","content":"_4858afc"};